import __ from "lodash";
import React, { Component, Fragment } from "react";
import { Alert, Button, Col, FormControl, Modal, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { cekCookies } from "../../../../../actions";
import accountManagement from "../../../../../apis/accountManagement";
import akmApi from "../../../../../apis/akmApi";
import eduprimeApi from "../../../../../apis/eduprimeApi";
import { CONFIG, CONFIG_API_BE, URL_AKM } from "../../../../../config";
import AddIcon from "@material-ui/icons/Add";

import Loader from "../../../../Loader";
import LoaderModal from "../../../../modal/LoaderModal";
import Navbar from "../../../navbar/Navbar";
import Sidebar from "../../../sidebar/Sidebar";

import Select from "react-select";
import { Grid, Input, InputLabel } from "@material-ui/core";

class MgtPsepSekolah extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            tahunAjaran: [],
            provinsi: [],
            kota: [],
            sekolah: [],
            kodeJenjangSekolah: null,
            namaSekolahSearch: null,
            taAktif: null,
            idProvinsi: null,
            idKabKota: null,
            idSekolah: null,
            listSekolah: [],
            listKabKota: [],
            listProvinsi: [],
            namaSekolah: null,
            openModal: false,
            idAdmin: null,
            namaAdmin: null,
            emailAdmin: null,
            passwordAdmin: null,
            usernameAdmin: null,
            teleponAdmin: null,
        };
    }

    async componentDidMount() {
        await this.props.cekCookies();
        if (!__.isEmpty(this.props.account)) {
            this.fetchProvinsi();
            this.fetchTa();
        }
    }

    fetchTa = async () => {
        const respons = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_LIST_TAHUN_AJARAN, {});
        if (respons) {
            if (!__.isEmpty(respons.data.data)) {
                this.setState({
                    tahunAjaran: respons.data.data,
                });
            }
        }
        respons.data.data.map((val, i) => {
            if (val.status === "1") {
                this.setState({ taAktif: val.kodeTahunAjaran });
            }
        });
    };

    fetchProvinsi = async () => {
        this.setState({ isFetching: true });
        const respons = await eduprimeApi.get(CONFIG_API_BE.API_GET_PROVINSI, {});
        if (respons) {
            if (!__.isEmpty(respons.data.list_provinsi)) {
                const dataProvinsi = { value: "", label: "Pilih Provinsi...", id: "idProvinsi", selected: "selected" };
                this.state.listProvinsi.push(dataProvinsi);
                respons.data.list_provinsi.map((val, i) => {
                    const dataProvinsi = { value: val.ID_PROVINSI, label: val.NAMA_PROVINSI, id: "idProvinsi" };
                    this.state.listProvinsi.push(dataProvinsi);
                });
            }
        }
        this.setState({ isFetching: false });
    };

    handleChangeSelect = async (e) => {
        const name = e.id;
        const id = e.value;
        this.setState({
            [e.id]: id,
            isFetching: true,
        });

        if (name === "idProvinsi") {
            this.setState({
                objectSekolah: {},
                listKabKota: [],
                listSekolah: [],
                kodeJenjangSekolah: null,
            });
            const respons = await eduprimeApi.get(CONFIG_API_BE.API_GET_KAB_KOTA + id, {});
            if (respons) {
                if (!__.isEmpty(respons.data.list_kab_kota)) {
                    const data = { value: "", label: "Pilih Kota...", id: "idKabKota", selected: "selected" };
                    this.state.listKabKota.push(data);
                    respons.data.list_kab_kota.map((val, i) => {
                        const data = { value: val.ID_KABUPATEN_KOTA, label: val.NAMA_KABUPATEN_KOTA, id: "idKabKota" };
                        this.state.listKabKota.push(data);
                    });
                }
            }
        }

        if (name === "idKabKota") {
            this.setState({
                objectSekolah: {},
                listSekolah: [],
            });

            const response = await akmApi.get(URL_AKM.FETCH_SEKOLAH_BY_ID_KAB + id).catch(function (error) {
                this.setState({ error });
            });

            if (response.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE) {
                this.setState({ listSekolahArray: response.data.data });
                const data = { value: "", label: "Pilih Sekolah...", id: "idSekolah", selected: "selected" };
                this.state.listSekolah.push(data);
                response.data.data.map((val, i) => {
                    const data = { value: val.idSekolah, label: val.namaSekolah, id: "idSekolah" };
                    this.state.listSekolah.push(data);
                });
            }
        }

        if (name === "idSekolah") {
            const response = await akmApi.get(URL_AKM.MANAGE_ACCOUNT_SCHOOL + id).catch(function (error) {
                this.setState({ error });
            });

            this.setState({ idSekolah: id });
            if (response.data.data) {
                if (response.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE) {
                    this.setState({ sekolah: response.data.data, namaSekolah: response.data.data.sekolah.namaSekolah });
                }
            }

            // console.log("====================================");
            // console.log("by school", this.state.searchBySchool);
            // console.log("====================================");
        }

        this.setState({ isFetching: false });
    };

    handleOpenModal = async (value) => {
        this.setState({ openModal: true });
        this.setState({ idAdmin: value.idAdmin, namaAdmin: value.namaAdminUser, usernameAdmin: value.username, emailAdmin: value.emailAdminUser, teleponAdmin: value.teleponAdminUser });
        console.log("====================================");
        console.log(this.state.usernameAdmin);
        console.log("====================================");
    };

    handleCloseModal = async () => {
        this.setState({ openModal: false });
    };

    handleChange = (e) => {
        const formData = { ...this.state };
        this.setState({ ...formData, [e.target.name]: e.target.value });
    };

    handleSubmit = async (e) => {
        e.preventDefault();

        // const data = {
        //     idAdmin: this.state.idAdmin ? this.state.idAdmin : null,
        //     namaAdminUser: this.state.namaAdmin,
        //     usernameAdmin: this.state.usernameAdmin,
        //     passwordAdmin: this.state.passwordAdmin,
        //     emailAdminUser: this.state.emailAdmin,
        //     telponAdmin: this.state.teleponAdmin,
        // };

        const getrespons = await akmApi
            .post(URL_AKM.MANAGE_ACCOUNT_SCHOOL + this.state.idSekolah, {
                idAdmin: this.state.idAdmin ? this.state.idAdmin : null,
                namaAdminUser: this.state.namaAdmin,
                usernameAdmin: this.state.usernameAdmin,
                passwordAdmin: this.state.passwordAdmin,
                emailAdminUser: this.state.emailAdmin,
                telponAdmin: this.state.teleponAdmin,
            })
            .catch(function (error) {});
        console.clear();
        console.log("====================================");
        // console.log("data", data);
        console.log("getrespons", getrespons);
        console.log("====================================");
        this.setState({ openModal: false });
        this.setState({ idAdmin: null, namaAdmin: null, usernameAdmin: null, emailAdmin: null, teleponAdmin: null });
    };

    render() {
        const idSekolah = this.state.idSekolah;
        const usernameAdmin = this.state.usernameAdmin;
        return (
            <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching} />
                <Sidebar account={this.props.account} />
                <div id="content" style={{ paddingBottom: "50px" }}>
                    <Navbar title="Manajemen PSEP Akun Sekolah" />
                    {this.loadAlert()}
                    {idSekolah !== null && (
                        <Row>
                            <Col sm={12} className="text-right">
                                <button className="btn btn-success mb-3" onClick={this.handleOpenModal}>
                                    <li className="fa fa-plus"></li> Tambah
                                </button>
                            </Col>
                        </Row>
                    )}
                    <Row>
                        <Col sm={4}>
                            Provinsi
                            <Fragment>
                                <Select options={this.state.listProvinsi} onChange={this.handleChangeSelect} placeholder="Pilih Provinsi..." />
                                <input tabIndex={-1} autoComplete="off" style={{ opacity: 0, height: 0 }} value={this.state.idProvinsi} required />
                            </Fragment>
                        </Col>
                        <Col sm={4}>
                            Kota/Kabupaten
                            <Fragment>
                                <Select options={this.state.listKabKota} onChange={this.handleChangeSelect} placeholder="Pilih Kabupaten / Kota..." />
                                <input tabIndex={-1} autoComplete="off" style={{ opacity: 0, height: 0 }} value={this.state.idKabKota} required />
                            </Fragment>
                        </Col>
                        <Col sm={4}>
                            Sekolah
                            <Fragment>
                                <Select options={this.state.listSekolah} onChange={this.handleChangeSelect} placeholder="Pilih sekolah..." />
                                <input tabIndex={-1} autoComplete="off" style={{ opacity: 0, height: 0 }} value={this.state.idSekolah} required />
                            </Fragment>
                        </Col>
                    </Row>
                    {this.loading()}
                    <Row>
                        <Col xs={12} md={12}>
                            {this.renderTableSekolah()}
                        </Col>
                    </Row>
                </div>
                <Modal show={this.state.openModal} aria-labelledby="example-custom-modal-styling-title" size="lg" backdrop="static" keyboard={false}>
                    <Modal.Header>
                        <Modal.Title>Akun Sekolah</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form onSubmit={this.handleSubmit}>
                            <Row style={{ marginBottom: 40 }}>
                                <Col>
                                    <Input type="text" name="idAdmin" onChange={this.handleChange} value={this.state.idAdmin} disabled />
                                </Col>
                                <Col>
                                    <Input type="text" name="namaAdmin" onChange={this.handleChange} value={this.state.namaAdmin} placeholder="Masukan Nama" />
                                </Col>
                                <Col>
                                    {this.state.usernameAdmin ? (
                                        <Input type="text" name="usernameAdmin" onChange={this.handleChange} value={this.state.usernameAdmin} placeholder="Masukan Username" disabled />
                                    ) : (
                                        <Input type="text" name="usernameAdmin" onChange={this.handleChange} value={this.state.usernameAdmin} placeholder="Masukan Username" />
                                    )}
                                </Col>
                            </Row>
                            <Row style={{ marginBottom: 40 }}>
                                <Col>
                                    <Input type="text" name="teleponAdmin" onChange={this.handleChange} value={this.state.teleponAdmin} placeholder="Masukan Telepon" />
                                </Col>
                                <Col>
                                    <Input type="text" name="emailAdmin" onChange={this.handleChange} value={this.state.emailAdmin} placeholder="Masukan Email" />
                                </Col>
                                <Col>
                                    <Input type="text" name="passwordAdmin" onChange={this.handleChange} value={this.state.passwordAdmin} placeholder="Masukan Password" />
                                </Col>
                            </Row>
                            <Grid item xs={12}>
                                <Button variant="danger" color="danger" style={{ float: "left" }} onClick={this.handleCloseModal}>
                                    <li className="fa fa-close"> Batal</li>
                                </Button>
                                <Button variant="primary" color="primary" type="submit" style={{ float: "right" }}>
                                    <li className="fa fa-save"> Simpan</li>
                                </Button>
                            </Grid>
                        </form>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }

    loading = () => {
        if (this.state.isSearch) {
            return <Loader />;
        }
    };

    loadAlert = () => {
        const { alertShow } = this.state;
        if (alertShow) {
            return (
                <Alert variant="danger" onClose={() => this.setState({ alertShow: false })} dismissible>
                    <strong>{this.state.resMessage}</strong>
                </Alert>
            );
        }
    };

    renderTableSekolah() {
        return (
            <table className="table table-sm table-striped table-hover">
                <thead>
                    <tr>
                        <th style={{ "text-align-last": "center" }}>No</th>
                        <th>Nama Sekolah</th>
                        <th>Nama Admin User</th>
                        <th>Username</th>
                        <th style={{ "text-align-last": "center" }}>Level</th>
                        <th style={{ "text-align-last": "center" }}>Status</th>
                        <th style={{ "text-align-last": "center" }}>Last Login</th>
                        <th style={{ "text-align-last": "center" }}>Aksi</th>
                    </tr>
                </thead>
                <tbody>{this.renderChildSekolah()}</tbody>
            </table>
        );
    }

    renderChildSekolah() {
        if (!__.isEmpty(this.state.sekolah)) {
            return this.state.sekolah.akun.map((val, i) => {
                return (
                    <tr>
                        <td style={{ "text-align-last": "center" }}>{i + 1}.</td>
                        <td>{this.state.namaSekolah}</td>
                        <td>{val.namaAdminUser}</td>
                        <td>{val.username}</td>
                        <td style={{ "text-align-last": "center" }}>{val.type}</td>
                        <td style={{ "text-align-last": "center" }}>{val.status === "AKTIF" ? <button className="btn btn-sm btn-outline-primary">Aktif</button> : <button className="btn btn-sm btn-outline-danger">Non Aktif</button>}</td>
                        <td style={{ "text-align-last": "center" }}>{val.lastLogin}</td>
                        <td style={{ "text-align-last": "center" }}>
                            <button className="btn btn-info btn-sm" onClick={() => this.handleOpenModal(val)}>
                                <li className="fa fa-edit"></li>
                            </button>
                        </td>
                    </tr>
                );
            });
        }
    }

    // doHandleRegis = async (stt, val) => {
    //     this.setState({ isSearch: true });
    //     const handleBukaTutup = await akmApi
    //         .post(URL_AKM.AKTFKAN_NONAKTIFKAN_SNMPTN, {
    //             ["idSekolah"]: val.idSekolah,
    //             ["idKabupatenKota"]: val.idKabupatenKota,
    //             ["idProvinsi"]: val.idProvinsi,
    //             ["namaSekolah"]: val.namaSekolah,
    //             ["kodeJenjangSekolah"]: val.kodeJenjangSekolah,
    //             // ["tahunAjaranSnmptn"]: stt,
    //             ["registrationDateSnmptn"]: 0,
    //         })
    //         .catch(function (error) {
    //             console.error(error);
    //         });

    //     this.fetchSekolahRefres(this.state.namaSekolahSearch);

    //     this.setState({ isSearch: false });
    // };
}

const mapStateToProps = (state) => {
    return {
        account: state.account,
    };
};

export default connect(mapStateToProps, { cekCookies })(MgtPsepSekolah);
